<template>
  <SimpleTextPopup
    :title="$t('detail')"
    v-model="value"
    @popupClose="$emit('input', false)"
    hideRgtBtn
    medium
  >
    <template v-slot:input>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-flex xs8 md6 lg5 xl4>{{ $t('deposit') }}: </v-flex>
          <v-flex xs4>$ {{ toMoney(transaction.amount) }}</v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <v-flex xs8 md6 lg5 xl4>{{ $t('balance') }}: </v-flex>
          <v-flex xs4>$ {{ toMoney(transaction.newBalance) }}</v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <v-flex xs8 md6 lg5 xl4>{{ $t('name') }}: </v-flex>
          <v-flex xs4>{{ transaction.clientName }}</v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <v-flex xs8 md6 lg5 xl4>{{ $t('transactionTime') }}: </v-flex>
          <v-flex xs4>{{ toTimestampString(transaction.createTime) }}</v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <v-flex xs8 md6 lg5 xl4>{{ $t('note') }}: </v-flex>
          <v-flex xs4>{{ transaction.note || '--' }}</v-flex>
        </v-layout>
        <v-layout align-center justify-center v-if="transaction.attachments && transaction.attachments.length">
          <v-flex xs7 md5 lg4 xl3>{{ $t('attachments') }}: </v-flex>
          <v-flex xs5>
          <v-layout row wrap>
            <FsFileChip
            v-for="(file, index) in (transaction.attachments || [])"
            :file="file"
            :key="'file' + index"
            width="100%"
            aspect-ratio="1.7"
          />
          </v-layout>
        </v-flex>
        </v-layout>
        <v-layout align-center justify-center v-if="!!transaction.offlineDepositDocId">
          <v-flex xs8 md6 lg5 xl4>{{ $t('offlineDepositId') }}: </v-flex>
          <v-flex xs4
            >{{ transaction.offlineDepositDocId }}
            <v-btn color="primary" small @click.stop="showOfflineDepositDialog()">{{
              $t('view')
            }}</v-btn></v-flex
          >
        </v-layout>
      </v-container>
      <ChatRoom
        v-model="isShowDepositDetailDialog"
        :title="$t('caseOfflineDeposit')"
        v-if="isShowDepositDetailDialog"
        enableFileUpload
        :docPath="['depositRequests', offlineDepositDetail._key||offlineDepositDetail.id]"
        :comments="offlineComments"
        readOnly
        ref="chatRoom"
        v-bind="offlineDepositDetail"
      >
        <template v-slot:issue>
          <v-card hover raised>
            <v-card-text>
              <div class="cardTitle">{{ $t('requestID') }}:{{offlineDepositDetail._key || offlineDepositDetail.id}}</div>
              <div class="cardTitle" style="overflow-wrap: break-word">
                {{ $t('createTime') }}: {{ toTimestampString(offlineDepositDetail.createTime) }}
              </div>
              <div
                v-if="warehouse"
                class="cardTitle"
                style="overflow-wrap: break-word"
              >
                {{ $t('organization') }}: {{ offlineDepositDetail.orgName }}
              </div>
              <div v-else class="cardTitle" style="overflow-wrap: break-word">
                {{ $t('vendor') }}: {{ offlineDepositDetail.vendorName }}
              </div>
              <div class="cardTitle">{{ $t('amount') }}: {{offlineDepositDetail.currencyType}}{{ offlineDepositDetail.amount}}</div>
              <div class="cardTitle">
                {{ $t('offlineType') }}:{{offlineDepositDetail.offlineType}}
              </div>
              <div class="cardTitle" style="overflow-wrap: break-word">
                {{ $t('note') }}:{{offlineDepositDetail.note}}
              </div>
              <div class="cardTitle">{{ $t('status') }}:{{offlineDepositDetail.status}}</div>
              <div class="cardTitle" style="overflow-wrap: break-word">
                {{ $t('lastModifiedTime') }}: {{ toTimestampString(offlineDepositDetail.lastModifiedTime || offlineDepositDetail.createTime) }}
              </div>
              <v-layout v-if="(offlineDepositDetail.uploadFiles || []).length" row wrap>
                <FsFileChip
                  v-for="(file, index) in offlineDepositDetail.uploadFiles"
                  :file="file"
                  :key="'file' + index"
                  width="100%"
                  aspect-ratio="1.7"
                  class="ma-2"
                />
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
      </ChatRoom>
    </template>
  </SimpleTextPopup>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup'
import FsFileChip from '@/components/FsFileChip'
import ChatRoom from '@/components/ChatRoom'
import { decimalTools, timeTools } from '../utils/tools'

export default {
  components: {
    SimpleTextPopup,
    FsFileChip,
    ChatRoom
  },
  mixins: [decimalTools, timeTools],
  data () {
    return {
      offlineDepositDetail: {},
      isShowDepositDetailDialog: false
    }
  },
  computed: {
    offlineComments () {
      return (this.offlineDepositDetail?.comments) || []
    },
    warehouse () {
      return this.$store.getters.activeWarehouse
    }
  },
  async mounted () {
    if (this.transaction.offlineDepositDocId) {
      this.offlineDepositDetail = await this.$store.dispatch('getOfflineDeposit', this.transaction.offlineDepositDocId) || {}
    }
  },
  methods: {
    showOfflineDepositDialog () {
      this.isShowDepositDetailDialog = true
    }
  },
  props: {
    value: Boolean,
    transaction: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TransactionDetailsPopup.vue